/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicineResponseDto
 */
export interface MedicineResponseDto {
    /**
     * Medicine ID
     * @type {string}
     * @memberof MedicineResponseDto
     */
    id: string;
    /**
     * Medicine name
     * @type {string}
     * @memberof MedicineResponseDto
     */
    name: string;
    /**
     * Medicine code
     * @type {string}
     * @memberof MedicineResponseDto
     */
    code?: string;
    /**
     * Active component
     * @type {string}
     * @memberof MedicineResponseDto
     */
    activeComponent?: string;
    /**
     * Unit
     * @type {string}
     * @memberof MedicineResponseDto
     */
    unit?: string;
    /**
     * Category name
     * @type {string}
     * @memberof MedicineResponseDto
     */
    categoryName?: string;
    /**
     * Manufacturer
     * @type {string}
     * @memberof MedicineResponseDto
     */
    manufacturer?: string;
    /**
     * Dosage information
     * @type {string}
     * @memberof MedicineResponseDto
     */
    dosage?: string;
    /**
     * Indication
     * @type {string}
     * @memberof MedicineResponseDto
     */
    indication?: string;
    /**
     * Contraindication
     * @type {string}
     * @memberof MedicineResponseDto
     */
    contraindication?: string;
    /**
     * Side effects
     * @type {string}
     * @memberof MedicineResponseDto
     */
    sideEffects?: string;
    /**
     * Additional data (JSON)
     * @type {object}
     * @memberof MedicineResponseDto
     */
    additionalData?: object;
    /**
     * Created at
     * @type {Date}
     * @memberof MedicineResponseDto
     */
    createdAt: Date;
    /**
     * Updated at
     * @type {Date}
     * @memberof MedicineResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the MedicineResponseDto interface.
 */
export function instanceOfMedicineResponseDto(value: object): value is MedicineResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MedicineResponseDtoFromJSON(json: any): MedicineResponseDto {
    return MedicineResponseDtoFromJSONTyped(json, false);
}

export function MedicineResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicineResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'activeComponent': json['activeComponent'] == null ? undefined : json['activeComponent'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'dosage': json['dosage'] == null ? undefined : json['dosage'],
        'indication': json['indication'] == null ? undefined : json['indication'],
        'contraindication': json['contraindication'] == null ? undefined : json['contraindication'],
        'sideEffects': json['sideEffects'] == null ? undefined : json['sideEffects'],
        'additionalData': json['additionalData'] == null ? undefined : json['additionalData'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function MedicineResponseDtoToJSON(json: any): MedicineResponseDto {
    return MedicineResponseDtoToJSONTyped(json, false);
}

export function MedicineResponseDtoToJSONTyped(value?: MedicineResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'activeComponent': value['activeComponent'],
        'unit': value['unit'],
        'categoryName': value['categoryName'],
        'manufacturer': value['manufacturer'],
        'dosage': value['dosage'],
        'indication': value['indication'],
        'contraindication': value['contraindication'],
        'sideEffects': value['sideEffects'],
        'additionalData': value['additionalData'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

